export default __webpack_public_path__ + "static/media/LetsGetStarted1.3ea7fe61.svg";